import React from 'react';
import "./styles.css";
/**
 * @function CenterColumnContainer 
 * @param {React.Component} children - React components or content that's being wrapped by the center column container.
 * @returns {React.Component}
 * @example
 * <CenterColumnContainer>
 *  <h1>Content</h1>
 * </CenterColumnContainer>
 */
export default function CenterColumnContainer(props) {
  return (
    <div className="center-column-container column set-width flex-container flex-vertical">
      {props.children}
    </div>
  );
}